import React from 'react';

import { Box, Container } from '@mui/material';
import Typography from '@mui/material/Typography';
import cx from 'classnames';

import { BREAKPOINTS_VALUES } from '../../theme';
import IKImage from '../IKImage/IKImage';
import LazyLoadImage from '../LazyloadImage/LazyLoadImage';
import { Button } from '../UI/Button';
import useStyles from './styles';

const ImageHeadingTextBlock = ({ data }) => {
  const background = data?.background;
  const desktopImg = data?.desktop_image;
  const classes = useStyles(background)();
  const items = data?.items;
  const heading = typeof data?.heading === 'string' ? data?.heading : data?.heading?.en;
  const buttonUrl = data?.button_url;
  const buttonText = data?.button_text;

  if (!items || items.length === 0) return null;

  return (
    <Box
      data-testid="imageHeadingBlock"
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'image-array-block',
      )}
    >
      <Container className={classes.container}>
        <Typography variant="h2" component="h2" align="center" className={classes.heading}>
          {heading}
        </Typography>

        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <div>
              {items &&
                items.map((item, index) => {
                  const heading =
                    typeof item?.heading === 'string' ? item?.heading : item?.heading?.en;
                  const description =
                    typeof item?.description === 'string'
                      ? item?.description
                      : item?.description?.en;

                  return (
                    <div key={index} className={cx(classes.item, 'image-array-block__item')}>
                      <div className={classes.imageWrap}>
                        <IKImage
                          path={item.image}
                          draggable={false}
                          alt={heading}
                          srcset={[{ width: 65 }, { width: 50 }]}
                          sizes={`(max-width:${BREAKPOINTS_VALUES['md']}px) 65px, 50px`}
                        />
                      </div>

                      <div className={classes.textWrapper}>
                        <Typography variant="h3" component="h3" className={classes.itemTitle}>
                          {heading}
                        </Typography>

                        <Typography className={classes.itemText}>{description}</Typography>
                      </div>
                    </div>
                  );
                })}
            </div>

            <div className={classes.imageMacWrap}>
              <LazyLoadImage
                imageWrapperClass={classes.imageWrapperClass}
                path={desktopImg}
                draggable={false}
                alt={heading}
                srcset={[{ width: 345 }, { width: 590 }]}
                sizes={`(max-width:${BREAKPOINTS_VALUES['lg']}px) 345px, 590px`}
              />
            </div>
          </div>

          <Button className={classes.btn} text={buttonText} link={buttonUrl} />
        </div>
      </Container>
    </Box>
  );
};

export default ImageHeadingTextBlock;
